import vi from "../types/vi";
import en from "../types/en";
import cn from "../types/cn";

export type Dictionary = typeof vi;

export const dictionaries = {
  vi,
  en: en as any as Dictionary,
  cn: cn as any as Dictionary,
} as const;

export type Locale = keyof typeof dictionaries;
